var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"buttons"},[_c('div',{staticClass:"article"},[_c('div',{staticClass:"article__body"},_vm._l((_vm.list),function(item,index){return _c('c-btn',{key:index,staticClass:"btn",attrs:{"href":item.link,"target":item.newTab ? '_blank' : '',"text":item.buttonName}})}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }